(function(window){
	window.cjs = window.createjs;

	Function.prototype.bind = Function.prototype.bind || function(object) {
		var t = this;
		return function() {
			return t.apply(object, arguments);
		};
	};

	if (typeof console === "undefined" || typeof console.log === "undefined") {
		console = {};
		console.log = function() {};
	}

	//Create Namespace
	window.cm = {

		main: null,

		modules: {},

		ready: false,
		baked: false,
		global: window,

		prefix: '',
		lib: 'js/',

		_current: null,
		_loadQueue: [],
		_waitForOnload: 0,

		$: function( selector ) {
			return selector[0] === '#' ? document.getElementById(selector.substr(1) ) : document.getElementsByTagName( selector );
		},

		$new: document.createElement.bind(document),

		debug: !!document.getElementById("cmDebug"),
		debugDiv: document.getElementById("cmDebug"),

		addClass: function(el, className)
		{
			if (el.classList)
			{
			  el.classList.add(className);
			}
			else
			{
			  el.className += ' ' + className;
			}
		},

		removeClass: function(el, className)
		{
			if (el.classList) 
			{
			  el.classList.remove(className);
			}
			else 
			{
			  el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			}
		},


		getUrlVar : function(name)
		{
			var vars = {};
			window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) { vars[key] = value; });
			return vars[name] || null;
		},

		copy: function( object ) {
			var c, i;
			if(
				!object || typeof(object) !== 'object' ||
				object instanceof HTMLElement ||
				object instanceof cm.Class
			) {
				return object;
			}
			else if( Array.isArray(object) ) {   // faster than instanceOf Array
				c = object.slice(0);
				for( i = 0 ; i <c.length; i++) {
					if ( c[i] && typeof(c[i]) === 'object') { c[i] = cm.copy(c[i]) ; }
				}
				return c;
			}
			else {
				c = {};
				for( i in object ) {
					c[i] = cm.copy(object[i]);
				}
				return c;
			}
		},

		merge: function( original, extended ) {
			for( var key in extended ) {
				var ext = extended[key];
				if(
					typeof(ext) !== 'object' ||
					ext instanceof HTMLElement ||
					ext instanceof cm.Class ||
					ext === null
				) {
					original[key] = ext;
				}
				else {
					if( !original[key] || typeof(original[key]) !== 'object' ) {
						original[key] = (ext instanceof Array) ? [] : {};
					}
					cm.merge( original[key], ext );
				}
			}
			return original;
		},

		module: function( name ) {
			if( cm._current ) {
				throw( "Module '"+cm._current.name+"' defines nothing" );
			}
			if( cm.modules[name] && cm.modules[name].body ) {
				throw( "Module '"+name+"' is already defined" );
			}

			cm._current = {name: name, requires: [], loaded: false, body: null};
			cm.modules[name] = cm._current;
			cm._loadQueue.push(cm._current);
			return cm;
		},

		requires: function() {
			cm._current.requires = Array.prototype.slice.call(arguments);
			return cm;
		},

		external : function() {
			var externalRequires = Array.prototype.slice.call(arguments);
			for (var i=0; i < externalRequires.length; i++) {
				if (!cm.modules[name]) cm._loadScript(externalRequires[i]);
			}
			return cm;
		},

		defines: function( body ) {
			cm._current.body = body;
			cm._current = null;
			cm._initDOMReady();
		},

		log: function(msg) {
			if(cm.debug) console.log(msg);
		},

		_loadScript: function( name, requiredFrom ) {
			cm.modules[name] = {name: name, requires:[], loaded: false, body: null};
			cm._waitForOnload++;

			var path = cm.prefix + cm.lib + name.replace(/\./g, '/') + '.js' + "?" + Date.now();
			//console.log(path);
			var script = cm.$new('script');
			script.type = 'text/javascript';
			script.onload = function() {
				cm._waitForOnload--;
				cm._execModules();
			};
			script.onerror = function() {
				throw(
					'Failed to load module '+name+' at ' + path + ' ' +
					'required from ' + requiredFrom
				);
			};
			script.src = path;
			cm.$('head')[0].appendChild(script);
		},

		_execModules: function() {
			var i, j, m, modulesLoaded = false;
			for( i = 0; i < cm._loadQueue.length; i++ ) {
				m = cm._loadQueue[i];
				var dependenciesLoaded = true;

				for( j = 0; j < m.requires.length; j++ ) {
					var name = m.requires[j];
					if( !cm.modules[name] ) {
						dependenciesLoaded = false;
						cm._loadScript( name, m.name );
					}
					else if( !cm.modules[name].loaded ) {
						dependenciesLoaded = false;
					}
				}

				if( dependenciesLoaded && m.body ) {
					cm._loadQueue.splice(i, 1);
					m.loaded = true;
					m.body();
					modulesLoaded = true;
					i--;
				}
			}

			if( modulesLoaded ) {
				cm._execModules();
			}

			// No modules executed, no more files to load but loadQueue not empty?
			// Must be some unresolved dependencies!
			else if( !cm.baked && cm._waitForOnload === 0 && cm._loadQueue.length !== 0 ) {
				var unresolved = [];
				for( i = 0; i < cm._loadQueue.length; i++ ) {

					// Which dependencies aren't loaded?
					var unloaded = [];
					var requires = cm._loadQueue[i].requires;
					for( j = 0; j < requires.length; j++ ) {
						m = cm.modules[ requires[j] ];
						if( !m || !m.loaded ) {
							unloaded.push( requires[j] );
						}
					}
					unresolved.push( cm._loadQueue[i].name + ' (requires: ' + unloaded.join(', ') + ')');
				}

				throw(
					'Unresolved (circular?) dependencies. ' +
					"Most likely there's a name/path mismatch for one of the listed modules:\n" +
					unresolved.join('\n')
				);
			}
		},

		_DOMReady: function() {
			if( !cm.modules['dom.ready'].loaded ) {
				if ( !document.body ) {
					return setTimeout( cm._DOMReady, 13 );
				}
				cm.modules['dom.ready'].loaded = true;
				cm._waitForOnload--;
				cm._execModules();
			}
			return 0;
		},

		_initDOMReady: function() {
			if( cm.modules['dom.ready'] ) {
				cm._execModules();
				return;
			}

			cm.modules['dom.ready'] = { requires: [], loaded: false, body: null };
			cm._waitForOnload++;
			document.addEventListener( 'DOMContentLoaded', cm._DOMReady, false );
			window.addEventListener( 'load', cm._DOMReady, false );
		}
	};

})(window);
